module.exports = __webpack_public_path__ + "static/media/instalogo.dc778790.jpg";